module.exports = __webpack_public_path__ + "img/silver.71ff97bf.png";